import { portfolioButtonStyles } from '../../../styles';

const styles = theme => ({
  ...portfolioButtonStyles(theme),
  paper: {
    // backgroundColor: theme.palette.background.banner,
    padding: theme.spacing(2),
  },
});

export default styles;
